import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';

import cView from './cView';

class cPdtList extends cView {
  //
  $id_stgs = { // 子で上書き
    cLoadCnd: () => bf.q('[cm50b11k]="{}"'.f(
//      global.c?.state.sgcd_pageCmns?.cm20_key,
      global.c?.state.sgcd_pageCmns?.cm20_key,
    )),
  };
  //
  $cd_stss = { // 親を上書き
    sld_cm50ss: {},
  };
  //
  $clp_loads = () => [ // 親を上書き
    cp.$cp_load_cm50({
      mode: 'items',
      state: 'sld_cm50ss',
//      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
//      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      cnd: global.c?.$id_stgs.cLoadCnd(),
    })
  ];
  //
  render() {
    return (
      <ce.RootList
        key={-1}
        b_logo={false}
        b_sch={true}
        onSchEnt={() => {
          _o_this.load()
        }}
        b_rhtVsb={true}
        rhtIconName='plus'
        rhtPfx='新規'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iPdtDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        n_bdyW={ic.gn_w}
        d_hdrs={{
          pfx: '',
          d_leftBtns: {},
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_cm50ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iPdtDtl',
              nextMode: 'show',
              keyName: 'cm50_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            }
          ]
        }}
      />
    );
  }
}

export default cPdtList;
